export default __webpack_public_path__ + "static/media/interMobileBanner.24e13788.webp";